/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderBoxTrackingNumberVo } from './OrderBoxTrackingNumberVo';
import {
    OrderBoxTrackingNumberVoFromJSON,
    OrderBoxTrackingNumberVoFromJSONTyped,
    OrderBoxTrackingNumberVoToJSON,
    OrderBoxTrackingNumberVoToJSONTyped,
} from './OrderBoxTrackingNumberVo';

/**
 * 
 * @export
 * @interface ResponseOrderBoxTrackingNumberVo
 */
export interface ResponseOrderBoxTrackingNumberVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderBoxTrackingNumberVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderBoxTrackingNumberVo
     */
    message?: string;
    /**
     * 
     * @type {OrderBoxTrackingNumberVo}
     * @memberof ResponseOrderBoxTrackingNumberVo
     */
    data?: OrderBoxTrackingNumberVo;
}

/**
 * Check if a given object implements the ResponseOrderBoxTrackingNumberVo interface.
 */
export function instanceOfResponseOrderBoxTrackingNumberVo(value: object): value is ResponseOrderBoxTrackingNumberVo {
    return true;
}

export function ResponseOrderBoxTrackingNumberVoFromJSON(json: any): ResponseOrderBoxTrackingNumberVo {
    return ResponseOrderBoxTrackingNumberVoFromJSONTyped(json, false);
}

export function ResponseOrderBoxTrackingNumberVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderBoxTrackingNumberVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderBoxTrackingNumberVoFromJSON(json['data']),
    };
}

export function ResponseOrderBoxTrackingNumberVoToJSON(json: any): ResponseOrderBoxTrackingNumberVo {
    return ResponseOrderBoxTrackingNumberVoToJSONTyped(json, false);
}

export function ResponseOrderBoxTrackingNumberVoToJSONTyped(value?: ResponseOrderBoxTrackingNumberVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderBoxTrackingNumberVoToJSON(value['data']),
    };
}

